import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { browserName, browserVersion } from 'react-device-detect';
import { Layout } from './components/Layout';
import { Footer } from './components/footer';
import  Home  from './components/Home';
import UserContext from './tools/contextLib';
import  NavMenu  from './components/NavMenu';
import  DormTrans  from './components/DormTrans';
import  AccessForbidden  from './components/AccessForbidden';
import  HonorsKeycardAccess  from './components/HonorsKeycardAccess';
import  RegistrarDashboard  from './components/RegistrarDashboard';
import  GenDormAccess  from './components/GenDormAccess';
import  Acadeum  from './components/Acadeum';
import  HeadCoaches  from './components/HeadCoaches';
import  Beacon  from './components/Beacon';
import  EmployeeDirectory  from './components/EmployeeDirectory';
import  Accounting  from './components/Accounting';
import  Admin  from './components/Admin';
import  SectionScheduling  from './components/SectionScheduling';
import  DepartmentHeads  from './components/DepartmentHeads';
import  CipCode  from './components/CipCode';
import  BeaconConn  from './components/BeaconConn';
import  Praxis  from './components/Praxis';
import  MergeDepartment from './components/MergeDepartment';
import  FormsDashboard  from './components/FormsDashboard';
import  TermsControlBB  from './components/TermsControlBB';
import  CounselorControl  from './components/CounselorControl';
import  ExamScheduling  from './components/ExamScheduling';
import  ContractDates  from './components/ContractDates';
import  VaxxRecord  from './components/VaxxRecord';
import  NoReplyEmail  from './components/NoReplyEmail';
import  AthleteKeycard  from './components/AthleteKeycardManagement';
import  VendorDB  from './components/VendorDB';
import  StuCheckCart  from './components/StuCheckCart';
import  DistroLists  from './components/DistroLists';
import DormAssign  from './components/DormAssign';
import RevokeAccess from './components/RevokeAccess';
import StudentDirectory from './components/StudentDirectory';
import  ClusterManage  from './components/ClusterManage';
import  DPR  from './components/DPR';
import DPRAdvisor from './components/DPR_Advisor'
import EmergencySalto from './components/EmergencySalto'
import BreakResidence from './components/BreakResidence'
import StopList from './components/StopList'
import FundToken from './components/FundToken'
import Exxat from './components/Exxat';
import SeparationManager from './components/Separation';
import IndiSalto from './components/IndiSalto';
import FY_Manager from './components/FY_Manager';
import HodsonSalto from './components/HodsonSalto';
import './custom.css'
import LoadingSpin from "react-loading-spin";

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType, InteractionStatus } from "@azure/msal-browser";
import moment from 'moment';

import store from './store';
import { useDispatch, useSelector } from 'react-redux';

export default function App() {
    const dispatch = useDispatch()
    //const { instance, accounts, inProgress } = useMsal();
    //useMsalAuthentication(InteractionType.Redirect);
    useEffect(() => {
        //localStorage.setItem("lastFetch", moment());
        dispatch({ type: 'foundation/setFetchTime' })
    }, [])
    return (
        <div>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <UnauthenticatedTemplate>
                    <div>
                        <LoadingSpin size="30px" primaryColor="#132E53" />
                    </div>
                </UnauthenticatedTemplate>
                <AuthenticatedTemplate>
                    <PageAuth  />
                    </AuthenticatedTemplate>
            </MsalAuthenticationTemplate>
        </div>)

}

const PageAuth = (props) => {
    const { instance, accounts, inProgress } = useMsal();
    const [currToken, setCurrToken] = useState();
    const [staleCheckTime, setStaleCheckTime] = useState(moment());
    const [refreshTicker, setRefreshTicker] = useState(1);
    let uthAcct = accounts.filter(acct => { if (window.location.host == "underthehood.hood.edu") { return acct.idTokenClaims.aud === "bcc2bb9d-a743-40ce-9d19-f617c997fe4b" } else { return acct.idTokenClaims.aud === "579a5cf4-f372-4d2b-9b4a-43700b470b88" } })
    instance.setActiveAccount(uthAcct);
    const accessTokenRequest = {
        scopes: ["user.read"],
        account: instance.getActiveAccount(),
        //account: accounts[0]
    };
    const dispatch = useDispatch()

    const selectLastFetch = state => state.lastFetch
    const selectAuthToken = state => state.apiKey
    const lastFetch = useSelector(selectLastFetch)
    const authToken = useSelector(selectAuthToken);

    useEffect(() => {
        //console.log("recycle check: compare " + Date.parse(localStorage.getItem("lastFetch")) + " to " + Date.parse(moment().subtract(45, 'm')));
        //console.log("time calculation: now " + moment() + ", hour ago: " + moment().minute(-45));
        if (Date.parse(lastFetch) <= Date.parse(moment().subtract(45, 'm'))) {
            //console.log("found stale. accounts: " + JSON.stringify(accounts));
            //localStorage.removeItem("webApiAccessToken");
            //localStorage.removeItem("lastFetch");

            //instance.logoutRedirect({
            //    account: instance.getActiveAccount(),
            //    postLogoutRedirectUri: "https://www.hood.edu"
            //});
            window.location.replace("https://www.hood.edu");

            //instance.acquireTokenRedirect({
            //    scopes: ["user.read"],
            //    account: accounts[0],
            //})
        }
        if (Date.parse(lastFetch) > staleCheckTime) {
            //console.log("need update");
            
            instance.acquireTokenSilent(accessTokenRequest)
                .then(function (accessToken) {
                    //console.log("access token found: " + JSON.stringify(accessToken.accessToken));
                    setCurrToken(accessToken.accessToken);
                    //localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                    dispatch({ type: "foundation/setApiKey", payload: accessToken.accessToken });
                }, function (error) {
                    instance.acquireTokenRedirect(accessTokenRequest).then(function (accessToken) {
                        //console.log("access token from redirect found: " + accessToken);
                        setCurrToken(accessToken);
                        //localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                        dispatch({ type: "foundation/setApiKey", payload: accessToken.accessToken });
                    }, function (error) {
                        //console.log("total failure: " + error);
                    })
                })
        }
        setStaleCheckTime(moment());
        setTimeout(() => { setRefreshTicker(refreshTicker + 1) }, 120000) //120000
    }, [refreshTicker])
    
    useEffect(() => {
        //console.log("initial state: ", store.getState())
        //const unsubscribe = store.subscribe(() => console.log("state after dispatch: " , store.getState()))
        //store.dispatch({ type: "foundation/setApiKey", payload: "skunk" })
        //store.dispatch({ type: 'foundation/setFetchTime', payload: moment() })
        //console.log("trying to get specific redux state value: " + store.getState().apiKey)
        //unsubscribe()

        //console.log("initial useEffect in PageAuth. checking: accounts.length = " + accounts.length + " and inProgress = " + inProgress)
        //console.log("active account: " + JSON.stringify(instance.getActiveAccount()))
        //const thisInstance = new PublicClientApplication({ auth: { clientId: "579a5cf4-f372-4d2b-9b4a-43700b470b88" } })
        //await thisInstance.initialize();
        //console.log("in initMSAL authResponse: " + authResponse.accessToken);
        //var result = instance.acquireTokenRedirect({scopes: ["user.read"],account: accounts[0]})
        if (accounts.length > 0 && (inProgress === InteractionStatus.None || instance.getActiveAccount() != null)) {
            ///console.log("acquiring token")
            instance.acquireTokenSilent(accessTokenRequest)
                .then(function (accessToken) {
                   // console.log("access token found: " + JSON.stringify(accessToken.accessToken));
                    
                    //getPages(accessToken.accessToken);
                    //localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                    dispatch({ type: "foundation/setApiKey", payload: accessToken.accessToken });
                    setCurrToken(accessToken.accessToken);
                    //var dateNow = new Date().toLocaleTimeString();
                    //console.log("datenow: " + new Date().toLocaleTimeString())
                    localStorage.setItem("lastFetch", moment());
                }, function (error) {
                    instance.acquireTokenRedirect(accessTokenRequest).then(function (accessToken) {
                        //console.log("access token from redirect found: " + accessToken);
                        
                        //getPages(accessToken);
                        //localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                        dispatch({ type: "foundation/setApiKey", payload: accessToken.accessToken });
                        setCurrToken(accessToken.accessToken);
                        //var dateNow = new Date().toLocaleTimeString();
                        //console.log("datenow: " + new Date().toLocaleTimeString())
                        localStorage.setItem("lastFetch", moment());
                    }, function (error) {
                        //console.log("total failure: " + error);
                    })
                })
            //.then(response => {
            //    console.log("response: " + JSON.stringify(response))
            //    if (response.accessToken) {
            //        console.log("access token: " + response.accessToken)
            //        setToken(response.accessToken);
            //        if (response.idToken) {
            //            console.log("id token: " + response.idToken)
            //            setIdToken(response.idToken)
            //        }
            //        else {console.log("no id token") }
            //        getPages(response.accessToken);
            //        //getAuthReq(response.accessToken);
            //    }
            //    else {
            //        console.log("no token");
            //    }
            //})
            ////.then(responseToken => { getPages() })
            //.catch(error => {
            //    console.log("error: " + error)
            //    if (error instanceof InteractionRequiredAuthError) {
            //        thisInstance.acquireTokenRedirect(accessTokenRequest)
            //    }
            //}
            //)
        }

        
        
        //fetch('user')
        //    .then((response) => response.json())
        //    .then((responseJSON) => {

        //        if (responseJSON.email != accounts[0].username) {
        //            let toSend = {
        //                serverUser: responseJSON.username,
        //                azureUser: accounts[0].username
        //            }
        //            fetch('RecordMismatch', {
        //                method: 'POST',
        //                headers: { 'Content-Type': 'application/json' },
        //                body: JSON.stringify(toSend)
        //            })
        //            setUserInfo(responseJSON);
        //            console.log("check failed");
        //            console.log("server data: " + JSON.stringify(responseJSON));
        //            console.log("azure data: " + JSON.stringify(accounts[0]));
        //        }
        //        //else { setUserInfo(responseJSON); }
        //    })
    }, [])

    //useEffect(() => {
    //    console.log("currToken update: " + currToken)
    //}, [currToken])

    let displaySite = <div></div>
    if (currToken != null && currToken != "undefined") {
        displaySite = < SiteView currToken={currToken} />
        //console.log("redering SiteView with currToken: " + currToken)
        //displaySite = <SiteView />
    }
    return (
        <div>
            <UnauthenticatedTemplate>
                <div></div>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                {displaySite}
            </AuthenticatedTemplate>
        </div>
     )
}

const SiteView = (props) => {
    const { instance, accounts, inProgress } = useMsal();
    let uthAcct = accounts.filter(acct => { if (window.location.host == "underthehood.hood.edu") { return acct.idTokenClaims.aud === "bcc2bb9d-a743-40ce-9d19-f617c997fe4b" } else { return acct.idTokenClaims.aud === "579a5cf4-f372-4d2b-9b4a-43700b470b88" } })
    instance.setActiveAccount(uthAcct);
    //console.log("SiteView");
    //static displayName = App.name;
    const [profile, setProfile] = useState(null);
    const [token, setToken] = useState(props.currToken);
    //const [profileSetter, setProfileSetter] = useState();//needed?
    const [returnable, setReturnable] = useState([]);
    const [selectables, setSelectables] = useState([]);
    const [globalLevel, setGlobalLevel] = useState("");
    const [globalDeptPK, setGlobalDeptPK] = useState(1);
    const [browser, setBrowser] = useState(`${browserName}${browserVersion}`);
    const [ip, setIP] = useState();
    const [pageName, setPageName] = useState("");
    const [levelSwitchFlag, setLevelSwitchFlag] = useState(false);
    const [pages, setPages] = useState([]);
    const [thisPage, setThisPage] = useState("/Home");
    const [userInfo, setUserInfo] = useState([]);
    const [graph, setGRAPH] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()

    const selectReduxState = state => state
    const reduxInfo = useSelector(selectReduxState)

        //this.state = {
        //    profile: null,
        //    setProfile: this.setProfile,
        //    returnable: [],
        //    selectables: ["3", "4"], //I like the pizza kind
        //    globalLevel: "Please select a browsing level",
        //    department: "",
        //    browser: `${browserName}${browserVersion}`,
        //    pageName: "",
        //    levelSwitchFlag: false,
        //    pages: [".", ","],
        //    thisPage: 1
        
        //populateDropdown(); //This is only called populateDropdown() because the function was copy/pasted from where the UserController fetch was first written in NavMenu.js
                                 //Regardless, it does the same thing of fetching user information
    
    //half of the functions here are probably outdated and can be pruned out
    const setGlobalStateCallback = (dataFromChild) => {
        //console.log("setGlobalStateCallback: " + dataFromChild);
        setLevelSwitchFlag(true);
        //this.setState({
        //    levelSwitchFlag: true //Yes, I'm doing two different setState functions, but I want to make sure this one is set before the next one
        //}) //This flag will be passed as a prop to all of the components, and when those components render they'll read this prop and redirect the user to Home.js if it's true. This way,
        //whenever a user changes their level, they'll immediately be sent home to avoid accidentally landing in AccessForbidden.js when all they did is change their level to a level
        //that doesn't have permission to see a page their previous level did
        let pk = dataFromChild.substring(0, dataFromChild.indexOf("|"))
        let display = dataFromChild.substring(dataFromChild.indexOf("|") + 1)
        setGlobalLevel(display);
        setGlobalDeptPK(pk);
        setThisPage("/Home")
        //this.setState({
        //    globalLevel: dataFromChild
        //});
        let bearerVAR = "Bearer " + reduxInfo.apiKey;
        let toSendVAR = {
            level: dataFromChild
        }
        //console.log("callback PageFind with toSend: " + JSON.stringify(toSendVAR))

        fetch('User', {
            method: 'GET',
            headers: {
                'Authorization': bearerVAR
            }
        }).then((response) => response.json())
            .then((responseJSON) => {
                setUserInfo(responseJSON)
                //const unsubscribe = store.subscribe(() => console.log("state after dispatch: ", store.getState()))
                dispatch({ type: 'foundation/setUserData', payload: responseJSON })
                //unsubscribe();
            })

        //fetch('PageFind', {
        //    method: 'POST',
        //    headers:
        //    {
        //        'Content-Type': 'application/json',
        //        'Authorization': bearerVAR
        //    },
        //    body: JSON.stringify(toSendVAR)
        //})
        //    .then((response2) => response2.json())
        //    .then((responseJSON2) => {
        //        setPages(responseJSON2);
        //    }).then((responseHandled) => {
        //        fetch('User', {
        //            method: 'GET',
        //            headers: {
        //                'Authorization': bearerVAR
        //            }
        //        }).then((response) => response.json())
        //            .then((responseJSON) => {
        //                setUserInfo(responseJSON)
        //                //const unsubscribe = store.subscribe(() => console.log("state after dispatch: ", store.getState()))
        //                dispatch({ type: 'foundation/setUserData', payload: responseJSON })
        //                //unsubscribe();
        //            })
        //    })
        //localStorage.setItem("lastFetch", moment());
        dispatch({ type: 'foundation/setFetchTime'})
    
        //getPages();
        setTimeout(() => { //This whole level switching state value to indicate when to redirect to home is a dumb stupid hack that wound up blocking access to any page but home when you change level
            setLevelSwitchFlag(false);
            //this.setState({ //and the fact that the fix for that was an even dumber stupider hack fills me with pride
            //    levelSwitchFlag: false
            //})
        }, 1200) //It's important to note in here that this timeout before this.state.levelSwitchFlag means that there's a second and a half long lockout where a user selecting a 
        //new page will not actually go to said page. This is fine, since the user will just assume they misclicked or something, it's only a second and a half
    }

    const setPageTitle = (dataFromChild) => {
        //this.setState({
        //    pageName: dataFromChild
        //})
        setPageName(dataFromChild);
    }

 

    //function findBrowserInfo(dataFromChild) { //This is from an old attempt at logging where I'd pass the page number to this function via props and it would do the logging.
    //    let toSend = { //Even though it didn't really work out, it's something I still want to investigate in the future
    //        pagePK: dataFromChild,
    //        department: this.state.returnable.level,
    //        userPCID: this.state.returnable.pcid,
    //        ip: this.state.returnable.ip,
    //        browser: this.state.browser,
    //        userID: this.state.returnable.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json' },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //}

    //function populateDropdown() {
    //    const response = await fetch('user');
    //    const data = await response.json();
    //    this.setState({
    //        returnable: data,
    //        loading: false,
    //        selectables: data.values,
    //        browser: `${browserName}${browserVersion}`
    //    });
    //    this.setState({
    //        globalLevel: this.state.returnable.level
    //    });
    //    this.getPages();
    //}

    useEffect(() => {
        //let inEffectIP;
        //fetch('https://api64.ipify.org?format=json', { dataType: 'jsonp' })
        //    .then((ipResponse) => ipResponse.json())
        //    .then((ipJSON) => {
        //        setIP(ipJSON.ip)
        //        inEffectIP = ipJSON.ip
        //    })
        let bearerVAR = "Bearer " + token;
        //console.log("in main useEffect. bearerVAR: " + bearerVAR)
        //console.log("alternate token: " + props.currToken)
        fetch('User', {
            method: 'GET',
            headers: {
                'Authorization': bearerVAR
            }
        })
            .then((response) => response.json())
            .then((responseJSON) => { setUserInfo(responseJSON) 
                //console.log("setting state : " + responseJSON.level + " and " + JSON.stringify(responseJSON.values))
                //console.log("dispatching ", JSON.stringify(responseJSON))
                const unsubscribe = store.subscribe(() => console.log("state after dispatch: ", store.getState()))
                dispatch({ type: 'foundation/setUserData', payload: responseJSON })
                unsubscribe();
                setIP(responseJSON.ip)
                setSelectables(responseJSON.values);
                setGlobalLevel(responseJSON.level.dept);
                setGlobalDeptPK(responseJSON.level.pk);
                setReturnable(responseJSON);
                let toSend = {
                    level: responseJSON.level.pk
                }
                fetch('PageFind', {
                    method: 'POST',
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': bearerVAR
                    },
                    body: JSON.stringify(toSend)
                    })
                    .then((response2) => response2.json())
                    .then((responseJSON2) => {
                        setPages(responseJSON2);
                        setLoading(true);
                        //console.log("reading length of redux userInfo: " , store.getState())
                    })
                    let toSend2 = {
                        pagePK: "/Home",
                        department: responseJSON.level.pk,
                        userPCID: responseJSON.pcid,
                        ip: responseJSON.ip,
                        browser: browser,
                        userID: responseJSON.username,
                        source: "useEffect"
                    }
                    fetch('logging', {
                        method: 'POST',
                        headers:
                        {
                            'Content-Type': 'application/json',
                            'Authorization': bearerVAR
                        },
                        body: JSON.stringify(toSend2)
                    })
            })
        
    }, [])

    //async getPages() {

    //    let toSend = {
    //        level: this.state.globalLevel
    //    }
    //    const response = await fetch('PageFind', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json' },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();

    //    this.setState({
    //        pages: data
    //    })
    //}

    const receiveNewPage = (pk) => {
        //console.log("receiveNewPage: " + pk)
        if (pk === 1) { setThisPage("/Home"); pk = "/Home" }
        else { setThisPage(pk); }
        let toSend = {
            pagePK: pk,
            department: globalDeptPK,
            userPCID: returnable.pcid,
            ip: ip,
            browser: browser,
            userID: returnable.username,
            source: "receiveNewPage"
        }
        //console.log("receiveNewPage toSend: ",toSend)
        let bearerVAR = "Bearer " + token;
        fetch('logging', {
            method: 'POST',
            headers:
            {
                'Content-Type': 'application/json',
                'Authorization': bearerVAR
            },
            body: JSON.stringify(toSend)
        })//.then((response) => response.json())
        //this.setState({
        //    thisPage: pk
        //})
    }

    const logoutCallback = () => {
        //let redirect;
        //if (window.location.host == "underthehood.hood.edu") {
        //    redirect = "undertheh";
        //}
        //else { msalInstance = new PublicClientApplication(msalConfigTEST) }
        instance.logoutRedirect({
            account: instance.getActiveAccount(),
            postLogoutRedirectUri: "https://www.hood.edu"
        });
    }

    //render() {
        //const globalLevel = globalLevel; //This is a way of pre-processing the information we're putting into context, to make sure it's being provided properly
        const nameOfUser = userInfo.tester;
        //const selectables = selectables;
        const PCID = userInfo.pcid;
        //const pageName = pageName;
        //const pages = pages;//If you add to the list of items being used in context, please add to the Teams documentation on upload
        //The only prop here that's necessary in the majority of the components is justSwitch since it's what lets the components know they need to redirect to Home due to a recent
        //level switch. However, in the future I plan on using setPageTitle to govern the page title content in NavMenu.js instead of simply using state changes inside the component
        //to get around the refresh issue. This is one of those things that is in the category "Important Things To Do right after this time-sensitive component that you just got now"
        if (window.location.pathname != '/') {
            return <Redirect to='/' />
    }

    //const myComponents = {
    //    accessForbidden: <AccessForbidden setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />,
    //    Home: <Home setPageTitle={setPageTitle} />,
    //    dormSpecialAccess: <DormTrans setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />,
    //    Acadeum: <Acadeum justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />,
    //    honorsKeycardAccess: <HonorsKeycardAccess setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />,
    //    registrarDashboard: <RegistrarDashboard setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />,
    //    HeadCoaches: <HeadCoaches justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} setPageTitle={setPageTitle} />,
    //    employeeDirectory: <EmployeeDirectory justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    accounting: <Accounting justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    admin: <Admin justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    sectionScheduling: <SectionScheduling justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    departmentHeads: <DepartmentHeads justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    CipCodes: <CipCode justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    BeaconConn: <BeaconConn justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    Praxis: <Praxis justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    FormsDashboard: <FormsDashboard justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    MergeDept: <MergeDepartment justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    termsControlBB: <TermsControlBB justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    counselorMaintenance: <CounselorControl justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    examScheduling: <ExamScheduling justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    contractDates: <ContractDates justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    QualtricsArchive: <VaxxRecord justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    NoReplyEmail: <NoReplyEmail justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    AthleteKeycard: <AthleteKeycard justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    VendorDB: <VendorDB justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} userData={returnable} />,
    //    StuCheckCart: <StuCheckCart justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />,
    //    DistroLists: <DistroLists justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    StuDormAssign: <DormAssign justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />,
    //    RevokeAccess: <RevokeAccess justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />
    //}
    //let CurrentComponent = myComponents["Home"]
    //console.log("selectables: " + JSON.stringify(selectables))
    let reduxState = store.getState()
    return (
        
        //passNewPage={this.receiveNewPage}
        //this.props.passNewPage(-1);
            <div>
            

            {  loading ? <Layout>
                <UserContext.Provider value={[globalLevel, nameOfUser, selectables, PCID, pageName, pages]}>
                    <NavMenu setGlobalStateCallback={setGlobalStateCallback} pageNameCheck={pageName} passNewPage={receiveNewPage} initPages={pages} logoutPROP={logoutCallback} />
                    
                    {thisPage == "/Home" && <Home setPageTitle={setPageTitle} />}
                    {thisPage == "NewPage" && <Beacon justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} setPageTitle={setPageTitle} />}
                    {thisPage == "/dormSpecialAccess" && <DormTrans setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} /> }
                {/*<Route path='/dormSpecialAccess' component={() => <DormTrans setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} resetSwitch={this.resetLevelSwitchFlag} />} />*/}
                    {thisPage == "/Acadeum" && <Acadeum justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} /> }
                    {thisPage == "/honorsKeycardAccess" && <HonorsKeycardAccess setPageTitle={setPageTitle} justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/registrarDashboard" && <RegistrarDashboard setPageTitle={setPageTitle} justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} />}
                    {thisPage == "NewPage" && <GenDormAccess setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} /> }
                    {thisPage == "/HeadCoaches" && <HeadCoaches justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} setPageTitle={setPageTitle} /> }
                    {thisPage == "/employeeDirectory" && <EmployeeDirectory justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/accounting" && <Accounting justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/admin" && <Admin justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/sectionScheduling" && <SectionScheduling justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage}  /> }
                    {thisPage == "/departmentHeads" && <DepartmentHeads justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/CipCodes" && <CipCode justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} />}
                    {thisPage == "/BeaconConn" && <BeaconConn justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/Praxis" && <Praxis justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/FormsDashboard" && <FormsDashboard justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/MergeDept" && <MergeDepartment justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/termsControlBB" && <TermsControlBB justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/counselorMaintenance" && <CounselorControl justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} /> }
                    {thisPage == "/examScheduling" && <ExamScheduling justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/contractDates" && <ContractDates justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/QualtricsArchive" && <VaxxRecord justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/NoReplyEmail" && <NoReplyEmail justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == "/AthleteKeycard" && <AthleteKeycard justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/VendorDB" && <VendorDB justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} userData={returnable} /> }
                    {thisPage == "/StuCheckCart" && <StuCheckCart justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} />}
                    {thisPage == "/DistroLists" && <DistroLists justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/StuDormAssign" && <DormAssign justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/RevokeAccess" && <RevokeAccess justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/StudentDirectory" && <StudentDirectory justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/ClusterManage" && <ClusterManage justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/DPR" && <DPR justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/DPRAdvisor" && <DPRAdvisor justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/EmergencySalto" && <EmergencySalto justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/BreakResidence" && <BreakResidence justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/StopList" && <StopList justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/FundToken" && <FundToken justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/Exxat" && <Exxat justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/Separation" && <SeparationManager justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/IndividualSalto" && <IndiSalto justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/FYManage" && <FY_Manager justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == "/HodsonSalto" && <HodsonSalto justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                {/*<Route path='/not-done-yet' component={UnderConstruction} />*/}
                    {thisPage == "/accessForbidden" && <AccessForbidden setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />}
                <Footer />
            </UserContext.Provider>
            </Layout > :
                <div><br /><br /><br /><br /><div className="centerDiv"><div class="loading">Loading...</div></div></div>
                /*<div><br /><br /><br /><br /><div className="centerDiv">Please hold...<br /><div className="centerDiv"><LoadingSpin size="30px" primaryColor="#86d3ff" /></div></div></div>*/
            }</div>
        ); //We use the arrow function syntax for components to route to in order to make sure we can pass props to it. NavMenu is not routed to because it should always be there
           //I know there are better ways to do that, but there are more important concerns with this site

           
   // }
}
